import React, { Component } from "react";
import { isIE, isFirefox, isSafari } from "react-device-detect";

const modalScrollBar = (ScrollBarComponent) => { 
  return class extends Component {

    componentDidMount() {
      if (this.props.show || this.props.showSpinner) {
        document.body.style.setProperty("overflow-y", "hidden", "important");
        if (isFirefox || isSafari) {
          document.getElementById("root").style.setProperty("padding-right", "1em", "important")
        }
        if(isIE){
          document.body.style.setProperty("-ms-overflow-style","-ms-autohiding-scrollbar","important")
        }
      }
    }

    componentDidUpdate(prevProps) {
      if ((this.props.show != prevProps.show) || this.props.showSpinner != prevProps.showSpinner) {
        if (this.props.show || this.props.showSpinner) {
          document.body.style.setProperty("overflow-y", "hidden", "important");
          if (isFirefox || isSafari) {
            document.getElementById("root").style.setProperty("padding-right", "1em", "important")
          }
        } else {
          if (isFirefox) {
            document.body.style.setProperty("overflow-y", "visible", "important");
            document.getElementById("root").style.setProperty("padding-right", "0", "important")
          } else {
            if(isSafari) {
              document.getElementById("root").style.setProperty("padding-right", "0", "important")
            }
            document.body.style.setProperty("overflow-y", "overlay", "important");
          }
        }
      }
    }

    componentWillUnmount() {
      if (isFirefox) {
        document.body.style.setProperty("overflow-y", "visible", "important");
        document.getElementById("root").style.setProperty("padding-right", "0", "important")
      } else {
        if(isSafari) {
          document.getElementById("root").style.setProperty("padding-right", "0", "important")
        }
        document.body.style.setProperty("overflow-y", "overlay", "important");
      }
    }

    render() {
      return (
        <ScrollBarComponent {...this.props} />
      );
    }
  };
};

export default modalScrollBar;